import { LOGIN_API } from '../api'
import axios from 'axios'

const OTPLogin = async (phoneNumber, otp) => {
    const ult = 'otp'
    const ut = 'customer'
    const payload = { ult, ut, phoneNumberRaw: phoneNumber, otp }
    console.log(payload)
    try {
        const res = await axios.post(LOGIN_API, { userData: payload })
        console.log(res)
        return res
    } catch (error) {
        return { success: false, error: error.message }
    }
}

export default OTPLogin
